module.exports = __webpack_public_path__ + "img/pound.708279ac.svg";